// Add this component for better mobile wallet connection
// You can add this to a new file: MobileWalletGuide.js

import React from 'react';

const MobileWalletGuide = ({ onConnect, isConnecting, error }) => {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  
  if (!isMobile) {
    return (
      <div className="glass-card" style={{ maxWidth: '500px', margin: '0 auto' }}>
        <h2 className="card-title">Connect Your Wallet</h2>
        <p className="card-text">
          Connect your wallet to create a Social Passport and verify your social accounts.
        </p>
        
        {error && (
          <div className="alert-error">
            <p>{error}</p>
          </div>
        )}
        
        <button
          onClick={onConnect}
          disabled={isConnecting}
          className="btn btn-gradient btn-lg"
          style={{ width: '100%' }}
        >
          {isConnecting ? (
            <>
              <span className="loader-sm"></span>
              <span>Connecting...</span>
            </>
          ) : (
            <>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="5" width="20" height="14" rx="2" ry="2"></rect>
                <path d="M16 14h.01"></path>
                <path d="M18 14h.01"></path>
                <path d="M20 9H4"></path>
              </svg>
              Connect Wallet
            </>
          )}
        </button>
      </div>
    );
  }

  return (
    <div className="glass-card" style={{ maxWidth: '500px', margin: '0 auto' }}>
      <h2 className="card-title">Connect Your Mobile Wallet</h2>
      
      {window.ethereum ? (
        <>
          <p className="card-text">
            Great! We detected a wallet in your browser. Click below to connect.
          </p>
          
          {error && (
            <div className="alert-error">
              <p>{error}</p>
            </div>
          )}
          
          <button
            onClick={onConnect}
            disabled={isConnecting}
            className="btn btn-gradient btn-lg"
            style={{ width: '100%', marginBottom: '1rem' }}
          >
            {isConnecting ? (
              <>
                <span className="loader-sm"></span>
                <span>Connecting...</span>
              </>
            ) : (
              <>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="5" width="20" height="14" rx="2" ry="2"></rect>
                  <path d="M16 14h.01"></path>
                  <path d="M18 14h.01"></path>
                  <path d="M20 9H4"></path>
                </svg>
                Connect Wallet
              </>
            )}
          </button>
        </>
      ) : (
        <>
          <p className="card-text">
            To use Passly on mobile, you'll need a Web3 wallet app. Here's how to get started:
          </p>
          
          <div className="mobile-wallet-steps">
            <div className="wallet-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h4>Install a Wallet App</h4>
                <p>Download MetaMask, Trust Wallet, or Rainbow from your app store</p>
              </div>
            </div>
            
            <div className="wallet-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h4>Open Passly in Your Wallet</h4>
                <p>Use your wallet's built-in browser to visit passly.xyz</p>
              </div>
            </div>
            
            <div className="wallet-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h4>Connect & Verify</h4>
                <p>Connect your wallet and start verifying your social accounts</p>
              </div>
            </div>
          </div>
          
          {error && (
            <div className="alert-error">
              <p>{error}</p>
            </div>
          )}
          
          <div className="mobile-wallet-buttons">
            <a 
              href="https://metamask.app.link/dapp/passly.xyz" 
              className="btn btn-gradient"
              style={{ width: '100%', marginBottom: '0.75rem' }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c2.5 0 4.74 1.02 6.36 2.64"/>
                <path d="M9 12l2 2 4-4"/>
              </svg>
              Open in MetaMask
            </a>
            
            <a 
              href="https://link.trustwallet.com/open_url?coin_id=60&url=https://passly.xyz" 
              className="btn btn-outline"
              style={{ width: '100%', marginBottom: '0.75rem' }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
              Open in Trust Wallet
            </a>
            
            <button
              onClick={() => {
                // Copy URL to clipboard for manual opening
                navigator.clipboard.writeText('https://passly.xyz');
                alert('URL copied! Open your wallet app and paste this URL in the browser.');
              }}
              className="btn btn-outline"
              style={{ width: '100%' }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
              </svg>
              Copy URL for Wallet Browser
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default MobileWalletGuide;